var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 11.975C10.1333 12.175 10.2833 12.275 10.5 12.275C10.7167 12.275 10.8667 12.175 10.95 11.975L12.05 9.55L14.475 8.45C14.675 8.36667 14.775 8.21667 14.775 8C14.775 7.78334 14.675 7.63334 14.475 7.55L12.05 6.45L10.95 4.025C10.8667 3.825 10.7167 3.725 10.5 3.725C10.2833 3.725 10.1333 3.825 10.05 4.025L8.95 6.45L6.525 7.55C6.325 7.63334 6.225 7.78334 6.225 8C6.225 8.21667 6.325 8.36667 6.525 8.45L8.95 9.55L10.05 11.975ZM0.500002 17.575V2C0.500002 1.45 0.696002 0.979002 1.088 0.587002C1.48 0.195002 1.95067 -0.000664969 2.5 1.69779e-06H18.5C19.05 1.69779e-06 19.521 0.196002 19.913 0.588002C20.305 0.980002 20.5007 1.45067 20.5 2V14C20.5 14.55 20.304 15.021 19.912 15.413C19.52 15.805 19.0493 16.0007 18.5 16H4.5L2.2 18.3C1.88334 18.6167 1.52067 18.6877 1.112 18.513C0.703335 18.3383 0.499335 18.0257 0.500002 17.575ZM2.5 15.175L3.675 14H18.5V2H2.5V15.175Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.e628703f.svg";
export { ForwardRef as ReactComponent };